var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h68v70H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.56 .12)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0FF",
    d: "M21 63h28v7H21zM25 11h13.75c3.27.07 5.71 1.7 7.32 4.9 1.87-3.27 4.45-4.9 7.75-4.9H68v29H25V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32h13.75c2.89.62 5.32 2.27 7.3 4.96A12.12 12.12 0 0 1 53.81 32H68v8H25v-8Z",
    fill: "#010ED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.96 63.91H20.01c-.4 0-.73-.22-.73-.5s.32-.51.73-.51h27.95c.4 0 .74.23.74.5 0 .29-.33.51-.74.51Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.63 70H20.2a.75.75 0 0 1-.75-.74V58.09h-4.11a6.35 6.35 0 0 1-6.36-6.33v-8.57H.75a.74.74 0 0 1-.68-1.05l5.92-13.26v-2.82A26.11 26.11 0 0 1 52.1 9.33c.27.31.23.78-.08 1.05a.75.75 0 0 1-1.06-.09 24.73 24.73 0 0 0-18.81-8.8h-.3A24.72 24.72 0 0 0 7.47 26.06v2.98c0 .1-.02.21-.06.3L1.9 41.7h7.83c.4 0 .74.34.74.75v9.3a4.86 4.86 0 0 0 4.87 4.85h4.86c.41 0 .75.33.75.74v11.17h26.93c.15-1.7-1.05-13.76 5.46-29.33a.75.75 0 0 1 1.39.57c-6.5 15.53-5.18 27.42-5.35 29.5 0 .42-.34.75-.75.75Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.92 40.58H25.1a.75.75 0 0 1-.74-.76V32.2c0-.2.08-.4.22-.54a.73.73 0 0 1 .52-.22h13.4a8.29 8.29 0 0 1 8.18 8.37c0 .42-.34.76-.75.76Zm-20.08-1.52h19.3a6.76 6.76 0 0 0-6.66-6.09H25.84v6.09Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.92 40.58a.73.73 0 0 1-.74-.72V17.92a6.42 6.42 0 0 0-6.5-6.33H25.84v21.02c0 .4-.34.72-.75.72a.73.73 0 0 1-.74-.72V10.87c0-.4.33-.73.74-.73h13.6a7.9 7.9 0 0 1 7.98 7.78v21.93c0 .4-.34.73-.75.73Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23 40.58H46.4a.75.75 0 0 1-.75-.76 8.29 8.29 0 0 1 8.19-8.37h13.39c.4 0 .74.34.74.76v7.6c0 .43-.33.77-.74.77Zm-20.05-1.52h19.3v-6.09H53.84a6.76 6.76 0 0 0-6.66 6.09Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 40.58a.73.73 0 0 1-.75-.73V17.92a7.9 7.9 0 0 1 7.99-7.78h13.59c.4 0 .74.33.74.73v21.74c0 .4-.33.72-.74.72a.73.73 0 0 1-.75-.72V11.59H53.64a6.42 6.42 0 0 0-6.5 6.33v21.94c0 .4-.33.72-.74.72ZM39.78 26.38h-9.56c-.44 0-.8-.23-.8-.51s.36-.5.8-.5h9.56c.44 0 .8.22.8.5s-.36.5-.8.5ZM35.81 20.29h-5.68c-.4 0-.71-.23-.71-.5 0-.29.32-.51.71-.51h5.68c.4 0 .71.22.71.5s-.32.51-.7.51Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.09 26.38h-9.57c-.44 0-.8-.23-.8-.51s.36-.5.8-.5h9.57c.44 0 .8.22.8.5s-.36.5-.8.5ZM60.16 20.29h-5.68c-.4 0-.71-.23-.71-.5 0-.29.32-.51.7-.51h5.69c.4 0 .71.22.71.5s-.32.51-.71.51Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/Industry.da135e46ebcd86186b8d57b4dd7ac162.svg";
export { ForwardRef as ReactComponent };